import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import studentRoutes from "@/router/items/student/StudentRoutes";
import staffRoutes from "@/router/items/staff/StaffRoutes";
import { isStudent, isStaff } from "@/app/util/host";

const routes = [] as RouteRecordRaw[];

/**
 * 현재 호스트 타입에 따라 라우트 추가
 */
if (isStudent) {
  routes.push(...studentRoutes);
} else if (isStaff) {
  routes.push(...staffRoutes);
}

/**
 * 라우터 생성
 */
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
